import { StyleSheet } from "react-native"
import { appColors, fontSize } from "../../appTheme"

export const viewTotalHoursWorkedStyle = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: appColors.lightBackgroundColor
    },
    headerText: {
        fontSize: fontSize?.mediumFontSize,
        marginBottom: 10
    },

    headerContainer: {
        backgroundColor: appColors.light,
        borderWidth: 1,
        borderColor: '#F1F5F9',
        marginBottom: 16,
        paddingVertical: 16,
        paddingHorizontal: 8,
        borderRadius: 16,
        flexDirection: 'row',
        alignItems: 'center',
        shadowColor: '#0F172A',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8,
        elevation: 2,
    },
    rowContainer: {
        backgroundColor: appColors.lightBackgroundColor,
        borderWidth: 1,
        borderColor: '#F1F5F9',
        marginBottom: 16,
        paddingVertical: 16,
        paddingHorizontal: 8,
        borderRadius: 16,
        flexDirection: 'row',
        alignItems: 'center',
        shadowColor: '#0F172A',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8,
        elevation: 2, flex: 1
    },
    // Shared flex properties to lock cells into perfect vertical grids
    cell: {
        flex: 1,
        textAlign: 'center',
    },
    dateCell: {
        flex: 1.2, // Gives slightly more room for date formats (e.g., "MM/DD/YYYY")
    },
    locationCell: {
        flex: 1.3, // Gives extra room for longer location names
    },
    divider: {
        width: 1,
        height: '100%',
        backgroundColor: appColors?.badgeColor, // Cleaner slate color instead of solid black
        marginHorizontal: 4,
    },

    tableHeader: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        borderWidth: 1,
        borderColor: appColors.lightGrey,
        marginTop: 8,
        borderRadius: 8,
        width: '100%',
    },

    tableHeaderView: {
        borderRightWidth: 1,
        borderColor: appColors.lightGrey,
    },

    textStyle1: {
        textAlign: 'center',
        color: appColors?.lightDark,
        borderBottomWidth: 1,
        borderColor: appColors.lightGrey,
        paddingVertical: 8,
        backgroundColor: appColors.lightBackgroundColor,
    },

    historyTableText: {
        textAlign: 'center',
        color: appColors?.lightDark,
        paddingVertical: 6,
        flexWrap: 'wrap'
    },
})